import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSort, Sort } from '@angular/material/sort';
import { Router, ActivatedRoute } from '@angular/router';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { SortDirection, SessionItems } from 'app/enums/constants.enum';
import { CaseDelete, CaseFilterDto, CaseList, CaseReportFilterDto, CasesFilter, CasesPaged, ReOpenCase } from 'app/models/cases/cases-list.model';
import { Item } from 'app/models/item.inferface';
import { AuthService } from 'app/services/auth.service';
import { CaseService } from 'app/services/cases.service';
import { DataSourceService } from 'app/services/data-source.service';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';
import { TenantSelectorService } from 'app/services/tenant-selector.service';
import { BehaviorSubject, merge, Subject } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { filter, switchMap, tap } from 'rxjs/operators';
import { Utils } from 'app/infrastructure/utils';
import { PermissionType } from 'app/enums/permission.enum';
import { DialogService } from 'app/dialogs/dialog.service';
import { ToastService } from 'app/services/toast.service';
import { WorkflowService } from 'app/services/workflow.service';
import { MassiveActionsReportModalComponent } from 'app/shared/components/massive-actions-report/massive-actions-modal/massive-actions-modal.component';
import { DataFiltered, StepFilteredDto } from 'app/models/dynamic-filters/dynamic-filters.model';
import { WorkflowTypeByModuleDto } from 'app/models/workflow/workflow.interface';
import { Modules } from 'app/enums/modules.enum';
import { DynamicFiltersService } from 'app/services/dynamic-filters.service';
import { DynamicFiltersModulesDescriptions } from 'app/enums/dynamic-filters-modules.enum';
import { AlertFilter } from 'app/models/alerts/alert-list.model';
import { ModulesDescription } from 'app/enums/modules-description.enum';
import { CaseAdvancedFilterData } from 'app/models/cases/cases-advanced-filter.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-cases-list',
  templateUrl: './cases-list.component.html',
  styleUrls: ['./cases-list.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None,
})
export class CasesListComponent implements OnInit {

  @ViewChild('sidenav') sideNavFilters: MatSidenav;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('dynamicFilterSidenav') sidenavDynamicFilter: MatSidenav;

  toggleIsTicketsTableView = false;
  toggleIsFilterPanelOpen = false;
  columns = [
        'TITLE',
        'Type.Description',
        'CREATEDDATE',
        'MODIFIEDDATE',
        'WorkflowInstance.CurrentStep.WorkflowStep.Title',
        'Status.Description',
    ];
    displayedColumns = [
        'SELECT',
        ...this.columns,
        'ACTIONS'
    ];
    sortings = [
        ...this.columns
    ];

  sortBy = '';
  sortOrder = SortDirection.DESC.toString();

  tableCountSubject = new BehaviorSubject<number>(0);
  dataSource: MatTableDataSource<CaseList> = new MatTableDataSource([]);
  dataTable$: Subject<CaseList[]> = new Subject();
  loadingDataSource = false;

  searchControl: UntypedFormControl;
  searchForm: UntypedFormGroup;
  searchFormAlert: UntypedFormGroup;
  timerRefresh: number;
  // tslint:disable-next-line: no-any
  private refreshInterval: number;

  private unsubscribeAll: Subject<void>;

  textFiltersMaxLength = 250;
  allCases: number;
  lastSuccessfulFilter:CasesFilter;

  statusData: Item[] = [];
  caseTypes: Item[] = [];
  sourcesData: Item[] = [];
  criticalitiesData: Item[] = [];
  addManualButton: boolean; 
  selectedList = [];
  allChecked: boolean = false;
  canGenerateReport:boolean;

  btnDynamicFilters: boolean = false;
  moduleSelectData: Item[] = [];
  workflowTypeIds: number[] = [];
  workflowsSelectData: Item[] = [];
  dynamicFiltersApplied: boolean;
  dynamicCaseFilters: StepFilteredDto;
  currentWorkflowSelected: number = 0;
  currentFilterStepSelected: number = 0;
  currentModuleSelected;
  workflowTypeByModule: WorkflowTypeByModuleDto[];
  toggleIsFDynacimFilterPanelOpen:boolean = false;
  panelExpanded: boolean = false;
  modulesAdvancedFilter: Item[] = [];
  loadingSearch: boolean = false;
  public MODULES = Modules;
  filtersCurrentModule: Item;



  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    authService: AuthService,
    private activatedRouter: ActivatedRoute,
    private dialogueService: DialogService,
    public fuseProggressBarService: FuseProgressBarService,
    private service: CaseService,
    private translateService: TranslateService,
    private tenantSelectorService: TenantSelectorService,
    public dialog: MatDialog,
    private datasourceService: DataSourceService,
    private toast: ToastService,
    private workflowService: WorkflowService,
    private dynamicFilterService: DynamicFiltersService,
  ) {
    this.unsubscribeAll = new Subject();
    this.timerRefresh = 60000;
    this.addManualButton = authService.userHasPermission(PermissionType.CaseAddManual);
    this.canGenerateReport = authService.userHasPermission(PermissionType.GenerateCaseReport);
    
    this.btnDynamicFilters = authService.userHasPermission(PermissionType.DynamicFiltersCaseDetail);
  

   }

  ngOnInit(): void {
    this.moduleSelectData = this.activatedRouter.snapshot.data.modules as Item[];
    // this.moduleSelectData = [{id: 2, description: 'Cases'}];
    this.workflowTypeByModule = this.activatedRouter.snapshot.data.workflowType as WorkflowTypeByModuleDto[];
    this.sourcesData = this.activatedRouter.snapshot.data.sources as Item[];
    this.criticalitiesData = this.activatedRouter.snapshot.data.criticalities as Item[];

    
  


    // console.log('prev tenantApplicationGroup');
    // console.log(this.modulesAdvancedFilter);
    this.datasourceService.getTenantApplicationGroup().subscribe(
      res => {
        console.log(res);
        this.modulesAdvancedFilter = res.filter(m => m.description != "Complaint");
        // console.log('post tenantApplicationGroup');
        // console.log(this.modulesAdvancedFilter);
      },
      err => console.log(err)
    );

    let filterForm = JSON.parse(MVLocalStorageService.getSessionItem(SessionItems.caselist_fitlerForm));
    this.searchControl = new UntypedFormControl('');

    const advancedFilters: CaseAdvancedFilterData = JSON.parse(MVLocalStorageService.getSessionItem(SessionItems.caselist_advancedFiltersApplied));
    this.filtersCurrentModule = advancedFilters?.module;
    if(advancedFilters?.module.description == ModulesDescription.Cases){
      filterForm = advancedFilters?.filter as CasesFilter;
    }

    this.searchForm = this.formBuilder.group({
      status: [filterForm?.status || null],
      title: [filterForm?.title || null],
      caseType: [filterForm?.caseType || null],
      createdDateFrom: [filterForm?.createdDateFrom || null],
      createdDateTo: [filterForm?.createdDateTo || null],
      modifiedDateFrom: [filterForm?.modifiedDateFrom || null],
      modifiedDateTo: [filterForm?.modifiedDateTo || null],
    });

    let alertForm;
    if(advancedFilters?.module.description == ModulesDescription.Alerts){
      alertForm = advancedFilters?.filter as AlertFilter;
    }
    
    this.searchFormAlert = this.formBuilder.group({ 
      number: [null],
      status: [alertForm?.status || null],
      // sources: [alertForm?.sources || null],
      resolutions: [alertForm?.resolutions || null],
      createdDateFrom: [alertForm?.createdDateFrom || null],
      createdDateTo: [alertForm?.createdDateTo || null],
      dueDateFrom: [alertForm?.dueDateFrom || null],
      dueDateTo: [alertForm?.dueDateTo || null],
      modifiedDateFrom: [alertForm?.modifiedDateFrom || null],
      modifiedDateTo: [alertForm?.modifiedDateTo || null],
      alertCode: [alertForm?.alertCode || null],
      sourceId: [alertForm?.sourceId || null],
      entity: [alertForm?.entity || null],
      description: [alertForm?.description || null],
      internalId: [alertForm?.internalId || null],
      criticalityId: [alertForm?.criticalityId || null],
      sourceCode: [alertForm?.sourceCode || null],
    });

    this.datasourceService.getCaseStatus().subscribe(
      res => this.statusData = res,
      err => console.log(err)
    );
    this.datasourceService.getCaseTypes().subscribe(
      res => this.caseTypes = res,
      err => console.log(err)
    );

    this.dynamicCaseFilters = JSON.parse(MVLocalStorageService.getSessionItem(SessionItems.caselist_dynamicFilters));
    this.dynamicFiltersApplied = JSON.parse(MVLocalStorageService.getSessionItem(SessionItems.caselist_dynamicFiltersApplied));
    this.currentWorkflowSelected = JSON.parse(MVLocalStorageService.getSessionItem(SessionItems.caselist_dynamicFilterWorkflowSelected));
    this.currentFilterStepSelected = JSON.parse(MVLocalStorageService.getSessionItem(SessionItems.caselist_dynamicFilterStepSelected)); 
    this.currentModuleSelected = MVLocalStorageService.getSessionItem(SessionItems.caselist_dynamicFilterModuleSelected) ?? null; 

    this.getPaged();
  }

  getPaged(): void{
    let successFilter: CasesFilter;
    const advancedFiltersApplied: CaseAdvancedFilterData = JSON.parse(MVLocalStorageService.getSessionItem(SessionItems.caselist_advancedFiltersApplied));
    this.dataTable$.pipe(
      switchMap(() => {
          const sort = !Utils.isNullOrWhiteSpace(this.sortBy) ? `${this.sortBy} ${this.sortOrder}` : 'CREATEDDATE desc';
          const filter: CasesFilter = {
            pageIndex: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize,
            sortExpression: sort,
            createdDateFrom: this.searchForm.controls.createdDateFrom?.value,
            createdDateTo: this.searchForm.controls.createdDateTo?.value,
            modifiedDateFrom: this.searchForm.controls.modifiedDateFrom?.value,
            modifiedDateTo: this.searchForm.controls.modifiedDateTo?.value,
            caseStatusIds: this.searchForm.controls.status?.value,
            caseTypeIds: this.searchForm.controls.caseType?.value,
            title: this.searchForm.controls.title?.value
          };
          successFilter = filter;
          this.fuseProggressBarService.show();

          if(this.dynamicFiltersApplied){
            this.dynamicCaseFilters.pageIndex = this.paginator.pageIndex;
            this.dynamicCaseFilters.pageSize = this.paginator.pageSize;
            this.dynamicCaseFilters.sortExpression = sort;
            
            switch (this.currentModuleSelected) {
                case DynamicFiltersModulesDescriptions.Cases:
                  return this.dynamicFilterService.applyFiltersCase(this.dynamicCaseFilters);
                
                case DynamicFiltersModulesDescriptions.Alerts:
                  return this.dynamicFilterService.applyFiltersCaseByAlert(this.dynamicCaseFilters);

                default:
                  return this.dynamicFilterService.applyFiltersCase(this.dynamicCaseFilters);
            }

          }else if (advancedFiltersApplied?.module.description == ModulesDescription.Alerts){
            const sort = !Utils.isNullOrWhiteSpace(this.sortBy) ? `${this.sortBy} ${this.sortOrder}` : 'CREATEDDATE desc';
            const filter: AlertFilter = advancedFiltersApplied.filter as AlertFilter;
            filter.pageIndex = this.paginator.pageIndex;
            filter.pageSize = this.paginator.pageSize;
            filter.sortExpression = sort;
            return this.service.getPagedByAlert(filter);
          }else{
            return this.service.getPaged(filter);
          }

      })
    ).subscribe((response: CasesPaged) => {
      this.dataSource.data = response.results;
      this.allCases = response.rowCount;
      this.tableCountSubject.next(response.rowCount);
      this.fuseProggressBarService.hide();
      this.lastSuccessfulFilter = {...successFilter, pageSize: response.rowCount, pageIndex: 0};
      // Save filters in Session Storage
      MVLocalStorageService.setSessionItem(SessionItems.caselist_pageSize, this.paginator.pageSize);
      MVLocalStorageService.setSessionItem(SessionItems.caselist_sortOrder, this.sortOrder);
      MVLocalStorageService.setSessionItem(SessionItems.caselist_sortBy, this.sortBy);
      MVLocalStorageService.setSessionItem(SessionItems.caselist_fitlerForm,
          JSON.stringify({ ...this.searchForm.value }));

    });

    const filterNav = MVLocalStorageService.getItem(SessionItems.caseSideNav);
      if (filterNav) {
        this.toggleIsFilterPanelOpen = filterNav;
      }
    const tableView = JSON.parse(MVLocalStorageService.getItem(SessionItems.caseTableView));
      if (tableView) {
        this.toggleIsTicketsTableView = tableView;
      }

    const dynamicFilterNav = MVLocalStorageService.getItem(SessionItems.caseDynamicFilterSideNav);
      if(dynamicFilterNav){
        this.toggleIsFDynacimFilterPanelOpen = dynamicFilterNav;
      }
  }

  ngAfterViewInit(): void {
    this.initialLoadData();

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    this.searchForm.valueChanges.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page)
        .pipe(
            tap(_ => {
                this.loadData();
            })
        )
        .subscribe();
  }

  ngOnDestroy() {
    this.unsubscribeAll.next(void 0);
    this.unsubscribeAll.complete();
    clearInterval(this.refreshInterval);
  }

  initialLoadData() {
    setTimeout(
        () => {
            const pageSize = MVLocalStorageService.getSessionItem(SessionItems.caselist_pageSize);
            if (pageSize) {
                this.paginator.pageSize = pageSize;
            }
            const sortOrder = MVLocalStorageService.getSessionItem(SessionItems.caselist_sortOrder);
            if (sortOrder) {
                this.sortOrder = sortOrder;
            }
            const sortBy = MVLocalStorageService.getSessionItem(SessionItems.caselist_sortBy);
            if (sortBy) {
                this.sortBy = sortBy;
            }
            this.dataTable$.next(void 0);
        }, 10
    );
    }

  loadData() {
    this.dataTable$.next(void 0);
  } 

  clearFilters() {
    this.searchForm.reset();
    this.loadData();
  }

  aplyFilters(): void {
    this.dynamicFiltersApplied = false;
    MVLocalStorageService.setSessionItem(SessionItems.caselist_dynamicFiltersApplied, this.dynamicFiltersApplied);
    this.loadData();
  }

  handleAdvancedFilters(dataFilter: CaseAdvancedFilterData){
    MVLocalStorageService.setSessionItem(SessionItems.caselist_advancedFiltersApplied, JSON.stringify(dataFilter));
    // console.log(dataFilter);
    if(dataFilter.module.description == ModulesDescription.Cases){
      this.fuseProggressBarService.show();
      this.searchForm.setValue(dataFilter.filter);
      const sort = !Utils.isNullOrWhiteSpace(this.sortBy) ? `${this.sortBy} ${this.sortOrder}` : 'CREATEDDATE desc';
      const filter: CasesFilter = dataFilter.filter as CasesFilter;
      filter.pageIndex = this.paginator.pageIndex;
      filter.pageSize = this.paginator.pageSize;
      filter.sortExpression = sort;
      this.service.getPaged(filter).subscribe(
        res => {
          this.dataSource.data = res.results;
          this.allCases = res.rowCount;
          this.tableCountSubject.next(res.rowCount);
          this.dataTable$ = new Subject();
          this.getPaged();
          setTimeout(() => {this.loadData()}, 300)
          this.fuseProggressBarService.hide();
        },
        err => {
          console.log(err);
          this.fuseProggressBarService.hide();
        }
      );
    }
    else if(dataFilter.module.description == ModulesDescription.Alerts){
      this.fuseProggressBarService.show();
      const sort = !Utils.isNullOrWhiteSpace(this.sortBy) ? `${this.sortBy} ${this.sortOrder}` : 'CREATEDDATE desc';
      const filter: AlertFilter = dataFilter.filter as AlertFilter;
      filter.pageIndex = this.paginator.pageIndex;
      filter.pageSize = this.paginator.pageSize;
      filter.sortExpression = sort;
      this.service.getPagedByAlert(filter).subscribe(
        res => {
          this.dataSource.data = res.results;
          this.allCases = res.rowCount;
          this.tableCountSubject.next(res.rowCount);
          this.dataTable$ = new Subject();
          this.getPaged();
          setTimeout(() => {this.loadData()}, 300)
          this.fuseProggressBarService.hide();
        },
        err => {
          console.log(err);
          this.fuseProggressBarService.hide();
        }
      );
    }
  }

  setSortingOrder(sort: string) {
    this.sortOrder = sort;
    this.loadData();
  }

  setSortingBy(sort: string) {
    this.sortBy = sort;
    this.loadData();
  }

  setMatSorting(sort: Sort) {
    if (this.sortBy !== sort.active) {
        this.setSortingBy(sort.active);
    }
    if (this.sortOrder !== sort.direction) {
        sort.direction = sort.direction || this.sortOrder == SortDirection.ASC ?
            SortDirection.DESC : SortDirection.ASC;
        this.setSortingOrder(sort.direction);
    }
  }

  toggleView(): void {
    this.toggleIsTicketsTableView = !this.toggleIsTicketsTableView;
    MVLocalStorageService.setItem(SessionItems.caseTableView, this.toggleIsTicketsTableView);
  }

  toggleFilterSideNav() {
    this.sideNavFilters.toggle();
    this.sidenavDynamicFilter.toggle(false);
    MVLocalStorageService.setItem(SessionItems.caseDynamicFilterSideNav, false);
    MVLocalStorageService.setItem(SessionItems.caseSideNav, this.sideNavFilters.opened);
  }

  //#region Table Actions
  listActions(event: any) {
    // console.log(event.action);
    // debugger;
    if (Utils.isNil(event)) { return; }
    switch (event.action) {
        case 'view':
            this.view(event.id);
            break;
        case 'reOpen':
            this.reOpen(event.id, event.workflowInstanceId);
            break;
        case 'deleteItem':
            this.deleteItem(event.id);
            break;
        case 'completeItem':
            this.complete(event.id);
            break;
        case 'followUpTask':
          this.viewCaseActions(event.id)
        // case 'edit':
        //     this.edit(event.id);
        //     break;
        default:
            break;
    }
}
view(id: number) {
    this.router.navigate(['cases/detail-case/' + id]);
}

// edit(id: number) {
//     this.router.navigate(['alert/edit-alert/' + id]);
// }

reOpen(id: number, workflowInstanceId: number) {
  this.workflowService.getStepNames(workflowInstanceId).subscribe(
    res => {
      const dialogRef = this.dialog.open(ReOpenCaseDialog, {
        width: '500px',
        data: res
      });
      dialogRef.afterClosed().subscribe(
        result => {
          const caseToReopen: ReOpenCase = {
            id: id,
            workflowStepId: result
          }
          this.fuseProggressBarService.show();
          this.service.reOpenCase(caseToReopen).subscribe(
            res => {
              this.fuseProggressBarService.hide();
              this.router.navigate(['cases/complete-case/' + id]);
            },
            err => {
              this.fuseProggressBarService.hide();
              console.log(err)
            }
          )
        }
      );
    },
    err => console.log(err)
  )
  
}

deleteItem(id: number) {
  let msg = this.translateService.instant("CASES.DELETE_CASE_CONFIRM");
  this.dialogueService.openConfirmDialog(null, msg)
  .afterClosed()
    .subscribe((confirmed: boolean) => {
      if(confirmed){
        const dialogRef = this.dialog.open(DeleteCaseDialog, {
          width: '500px',
          disableClose: true
        });
        dialogRef.afterClosed().subscribe(
          data => {
            if(data){
              const caseDelete: CaseDelete = {
                id: id,
                deletedReasonDetail: data
              }
              this.fuseProggressBarService.show();
              this.service.deleteCase(caseDelete).subscribe(
                res => {
                  this.fuseProggressBarService.hide();
                  this.toast.success(this.translateService.instant("CASES.DELETE_SUCCESS"));
                  this.loadData();
                },
                err => {
                  this.fuseProggressBarService.hide();
                  console.log(err);
                }
              );
            }
          }
        )
      }
    });
  }

  complete(id: number) {
      this.router.navigate(['cases/complete-case/' + id]);
  }

  viewCaseActions(id: number){
    this.router.navigate(['cases/case-follow-up-task/' + id]);
  }

  //#endregion

  // Check items to massive actions
  itemCheck(item, e) {
    if (e.checked) {
        this.selectedList.push(item.id);
    } else {
        if (this.selectedList.includes(item.id)) {
            const i = this.selectedList.indexOf(item.id);
            this.selectedList.splice(i, 1);
        }
    }
  }

  checkAll(e) {
    if (e.checked) {
        this.allChecked = true;
        this.dataSource.data.map(item => {
            item.selected = true;
            this.selectedList.push(item.id);
        });
    } else {
        this.allChecked = false;
        this.dataSource.data.map(item => {
            item.selected = false;
            this.selectedList = [];
        });
    }
  }

  generateReport(){
    const dialogRef = this.dialog.open(MassiveActionsReportModalComponent, {
        width: '500px',
        panelClass: 'associate-alert-dialog',
        data: {
          selectedList: this.selectedList,
          allItems: this.allCases,
          dataLabel: "CASES.REPORT.COMFIRM_SELECTED",
          labelSelectAll:"CASES.MASSIVE_ACTIONS.SELECT_ALL",
          selectAttachments: true
        },
    });
    dialogRef.afterClosed()
    .pipe(filter(response => !!response))
    .subscribe(result => {
      const reportReq: CaseReportFilterDto = {
          downloadAttachments: result.downloadAttachments,
          selectedAll: result.selectedAll,
          selectedList: result.selectedList,
          caseFilters: this.lastSuccessfulFilter
      };
      this.fuseProggressBarService.show();
      this.service.generateReportCase(reportReq).subscribe(
          () => {
            this.fuseProggressBarService.hide();
            this.toast.success(this.translateService.instant('CASES.REPORT.REQUEST_GENERATED'))
            this.loadData();
            this.allChecked = false;
            this.selectedList = [];
          },
          err => {
            this.fuseProggressBarService.hide();
            this.toast.error(err)
          }
      )
    })
  }

  openDynamicFilters(){
    this.sidenavDynamicFilter.toggle();
    this.sideNavFilters.toggle(false);
    this.toggleIsFilterPanelOpen = false;
    MVLocalStorageService.setItem(SessionItems.caseDynamicFilterSideNav, this.sidenavDynamicFilter.opened);
    MVLocalStorageService.setItem(SessionItems.caseSideNav, false);
  }

  onModuleSelected(moduleSelected: string): void {
    if(moduleSelected){
      this.currentModuleSelected = moduleSelected;
      MVLocalStorageService.setSessionItem(SessionItems.caselist_dynamicFilterModuleSelected, moduleSelected);
    }
  }

  onWorflowSelected(workflowSelect: number){
    if(workflowSelect){
      MVLocalStorageService.setSessionItem(SessionItems.caselist_dynamicFilterWorkflowSelected, workflowSelect);
    }
  }

  onStepSelected(stepSelected: number){
    if(stepSelected){
      MVLocalStorageService.setSessionItem(SessionItems.caselist_dynamicFilterStepSelected, stepSelected);
    }
  }

  handleApplyFilters(dataStepFiltered: DataFiltered){
      const sort = !Utils.isNullOrWhiteSpace(this.sortBy) ? `${this.sortBy} ${this.sortOrder}` : 'CREATEDDATE desc';
      dataStepFiltered.stepFilteredDto.pageIndex = this.paginator.pageIndex;
      dataStepFiltered.stepFilteredDto.pageSize = this.paginator.pageSize;
      dataStepFiltered.stepFilteredDto.sortExpression = sort;
      this.dynamicCaseFilters = dataStepFiltered.stepFilteredDto;
      MVLocalStorageService.setSessionItem(SessionItems.caselist_dynamicFilters, JSON.stringify(this.dynamicCaseFilters));

      if(dataStepFiltered.moduleId == this.MODULES.Alerts){
        this.applyCaseByAlertFilter(dataStepFiltered.stepFilteredDto);
      }else{
        this.applyDynamicFilter(dataStepFiltered.stepFilteredDto);
      }
      
  }

  applyDynamicFilter(dataStepFiltered: StepFilteredDto){
    this.loadingSearch = true;
    this.fuseProggressBarService.show();
    this.dynamicFilterService.applyFiltersCase(dataStepFiltered).subscribe(
      res => {
        this.loadingSearch = false;
        this.dynamicFiltersApplied = true;
        MVLocalStorageService.setSessionItem(SessionItems.caselist_dynamicFiltersApplied, this.dynamicFiltersApplied);
        this.dataSource.data = res.results;
        this.allCases = res.rowCount;
        this.tableCountSubject.next(res.rowCount);
        this.selectedList = [];
        this.fuseProggressBarService.hide();
      },
      err => {
        this.loadingSearch = false;
        console.log(err);
        this.toast.error(this.translateService.instant('errors.ErrUnexpected'));
        this.dynamicFiltersApplied = false;
        MVLocalStorageService.setSessionItem(SessionItems.caselist_dynamicFiltersApplied, this.dynamicFiltersApplied);
        this.fuseProggressBarService.hide();
      }
    )
  }

  applyCaseByAlertFilter(dataStepFiltered: StepFilteredDto){
    this.loadingSearch = true;
    this.fuseProggressBarService.show();
    this.dynamicFilterService.applyFiltersCaseByAlert(dataStepFiltered).subscribe(
      res=> {
        this.loadingSearch = false;
        this.dynamicFiltersApplied = true;
        MVLocalStorageService.setSessionItem(SessionItems.caselist_dynamicFiltersApplied, this.dynamicFiltersApplied);
        this.dataSource.data = res.results;
        this.allCases = res.rowCount;
        this.tableCountSubject.next(res.rowCount);
        this.selectedList = [];
        this.fuseProggressBarService.hide();
      },
      err => {
        this.loadingSearch = false;
        console.log(err);
        this.toast.error(this.translateService.instant('errors.ErrUnexpected'));
        this.dynamicFiltersApplied = false;
        MVLocalStorageService.setSessionItem(SessionItems.caselist_dynamicFiltersApplied, this.dynamicFiltersApplied);
        this.fuseProggressBarService.hide();
      }
    );
  }

  onClearFilters(data: {filtersClear: boolean, dataStepFiltered: DataFiltered}){
    if(data.filtersClear){
      this.handleApplyFilters(data.dataStepFiltered);
    }
  }

  onClearAllFilters(filtersClear: boolean){
    if(filtersClear){
      this.dynamicFiltersApplied = false;
      MVLocalStorageService.setSessionItem(SessionItems.caselist_dynamicFiltersApplied, this.dynamicFiltersApplied);
      this.currentWorkflowSelected = 0;
      MVLocalStorageService.setSessionItem(SessionItems.caselist_dynamicFilterWorkflowSelected, this.currentWorkflowSelected);
      this.loadData();
    }
  }

}


//Modal ReOpen Case Workflow Steps Instance
@Component ({
  selector: 'reopen-case-dialog',
  template:  `
                <div>
                    <h2 class="text-center">{{"CASES.SELECT_STEP" | translate}}</h2>
                    <div>
                    <mat-action-list>
                      <ng-container *ngFor="let step of data">
                        <mat-list-item *ngIf="step.isCompleted || step.isCurrentStep"  (click)="selectStep(step.workflowStepId)">
                              <mat-icon color="primary" mat-list-icon>arrow_forward</mat-icon>
                              <button mat-list-item > {{step.workflowStepTitle}}</button>
                          </mat-list-item>
                      </ng-container>
                    </mat-action-list>  
                    </div>
                </div>
              `
})
export class ReOpenCaseDialog {
  
  constructor(
    public dialogRef: MatDialogRef<ReOpenCaseDialog>,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selectStep(id){
    this.dialogRef.close(id);
  }
}

//GetStepPrevInstanceDialog
@Component({
      selector: 'get-step-previnstance-dialog',
      template: `
                  <div>
                    <h2 class="text-center">{{"CASES.PREV_STEP.TITLE" | translate}}</h2>
                    <div style="text-align:center">
                      <button mat-raised-button color="primary" class="my-8 mx-24" (click)="selectOption(false)">{{"CASES.PREV_STEP.NO" | translate}}</button>
                      <button mat-raised-button color="secondary" class="my-8 mx-24" (click)="selectOption(true)">{{"CASES.PREV_STEP.YES" | translate}}</button>
                    <div>
                  </div>
                `
})

export class GetStepPrevInstanceDialog {

  constructor(
    public dialogRef: MatDialogRef<GetStepPrevInstanceDialog>,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
  ) {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selectOption(option: boolean){
    // console.log(option);
    this.dialogRef.close(option);
  }
}

//DeleteCaseDialog
@Component({
  selector: 'delete-case-dialog',
  template: `
              <div>
                  <h2>{{"CASES.DELETE_REASON" | translate}}</h2>
                  <form [formGroup]="form">
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
                      <textarea matInput rows="6" #textarea formControlName="deleteReasonDetail" maxlength="1024" placeholder="{{'CASES.REASON' | translate}}">
                      </textarea>
                    </mat-form-field>
                  </form>
                  <div align="end">
                    <mat-hint>{{deleteReasonDetailInputLenght}} / {{maxLength}}</mat-hint>
                    </div>
                  <div align="end">
                    <button mat-raised-button color="accent" class="m-8" (click)="onCancel()">{{'BUTTONS.CANCEL' | translate}}</button>
                    <button mat-raised-button color="primary" class="my-8" [disabled]="form.invalid" (click)="onSendCaseDelete()">{{'BUTTONS.SEND' | translate}}</button>
                  </div>
                  
              </div>
            `
})

export class DeleteCaseDialog {

  form: UntypedFormGroup;
  deleteReasonDetailInputLenght = 0;
  maxLength = 1024;
  constructor(
    public dialogRef: MatDialogRef<DeleteCaseDialog>,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
  ){
    this.form = this.fb.group({
      deleteReasonDetail: ['', [Validators.required, Validators.minLength(10),Validators.maxLength(1024)]]
    });
    this.form.valueChanges.subscribe(
      change => {
        this.deleteReasonDetailInputLenght = this.form.get('deleteReasonDetail').value?.length;
      }
    );
  }

  onSendCaseDelete(){
    this.dialogRef.close(this.form.get('deleteReasonDetail').value);
  }

  onCancel(){
    this.dialogRef.close(false);
  }
}